import React from "react";
import { FormattedMessage } from "react-intl";

import * as Yup from "yup";

import { yupObjectValidation } from "../../../validationServices";

export const useOrganizationValidationSchema = () => {
  const initialValues = {
    companyName: "",
    phoneNumber: "",
    city: "",
    zipcode: "",
    street: "",
    state: "alaska",
    domain: "",
    companyType: "type1",
  };

  const validationSchema = {
    companyName: yupObjectValidation.company_name4,
    domain: Yup.string()
      .trim(<FormattedMessage id="YUP.SPACE_NOT_ALLOWED" />)
      .min(3, <FormattedMessage id="YUP.MINIMUM_3" />)
      .max(50, <FormattedMessage id="YUP.MAXIMUM_50" />)
      .required(<FormattedMessage id="YUP_DOMAIN_REQUIRED" />),
    city: Yup.string()
      .trim(<FormattedMessage id="YUP.SPACE_NOT_ALLOWED" />)
      .required(<FormattedMessage id="YUP_CITY_REQUIRED" />),
    zipcode: Yup.string()
      .min(5, <FormattedMessage id="YUP.MINIMUM_5" />)
      .required(<FormattedMessage id="YUP_ZIP_REQUIRED" />),
    street: Yup.string()
      .trim(<FormattedMessage id="YUP.SPACE_NOT_ALLOWED" />)
      .required(<FormattedMessage id="YUP_STREET_REQUIRED" />),
  };

  const organizationValidationSchema = Yup.object().shape(validationSchema);

  return {
    initialValues,
    organizationValidationSchema,
  };
};
